import { Loader2 } from "lucide-react";
import { Check } from "lucide-react";
import { type HTMLAttributes, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type Props = {
  disabled: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
  size?: ButtonProps["size"];
  className?: HTMLAttributes<HTMLButtonElement>["className"];
  variant?: ButtonProps["variant"];
  label?: string;
  icon?: React.ReactNode;
  onFocus?: (event: React.FocusEvent<HTMLButtonElement>) => void;
};

export const ConfirmBankTransactionBookingsButton = ({
  disabled,
  onClick,
  size = "default",
  variant,
  className,
  label,
  icon,
  onFocus,
}: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleConfirmTransactionBooking = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setLoading(true);

    try {
      await onClick(event);
    } finally {
      setLoading(false);
    }
  };

  const handleFocus = (event: React.FocusEvent<HTMLButtonElement>) => {
    onFocus?.(event);
  };

  return (
    <Button
      className={cn("gap-1", className)}
      disabled={disabled || loading}
      size={size}
      onClick={handleConfirmTransactionBooking}
      variant={variant}
      onFocus={handleFocus}
      type="submit"
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        icon || <Check className="w-4 h-4" />
      )}
      {label || t("transactions.accounting.panel.booking.status.approve")}
    </Button>
  );
};
